import React from 'react';
import { Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { DataTableButton } from 'src/components/DataTable/components/DataTableButton/DataTableButton';

export interface DataTableSelectionActionsProps {
  primaryActionName?: string;
  secondaryActionName?: string;
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
  isLoading: boolean;
}

export const DataTableSelectionActions: React.FC<DataTableSelectionActionsProps> =
  ({
    primaryActionName,
    secondaryActionName,
    onPrimaryAction,
    onSecondaryAction,
    isLoading,
  }) => {
    if (!primaryActionName && !secondaryActionName) {
      return null;
    }

    return (
      <Flex alignItems="center">
        {primaryActionName && (
          <Stack x="sm">
            <DataTableButton
              variant="primary"
              buttonSize="medium"
              onClick={onPrimaryAction}
              disabled={isLoading}
              isLoading={isLoading}
            >
              {primaryActionName}
            </DataTableButton>
          </Stack>
        )}
        {secondaryActionName && (
          <Stack>
            <DataTableButton
              variant="secondary"
              buttonSize="medium"
              onClick={onSecondaryAction}
              disabled={isLoading}
            >
              {secondaryActionName}
            </DataTableButton>
          </Stack>
        )}
      </Flex>
    );
  };
